// Origens / CDs do embarcador — PO1-2380 (épico PO1-2374): locais de onde a
// mercadoria sai (EmbarcadorRemetente no TMS). Rotas /origens/* do backend_hub
// (instância `api`); o embarcador vai explícito (o selecionado no topo).
import api from "./api";

export async function listarOrigens(embarcadorId) {
  const { data } = await api.get("/origens", { params: { embarcadorId } });
  return data;
}

export async function criarOrigem(dados) {
  const { data } = await api.post("/origens", dados);
  return data;
}

export async function atualizarOrigem(id, dados) {
  const { data } = await api.put(`/origens/${id}`, dados);
  return data;
}

export async function removerOrigem(id, embarcadorId) {
  const { data } = await api.delete(`/origens/${id}`, { params: { embarcadorId } });
  return data;
}

// Mensagem de erro do backend (error + errors por campo) ou um texto padrão.
export function mensagemErroOrigem(err, padrao) {
  const data = err && err.response && err.response.data;
  if (data && data.errors && typeof data.errors === "object") {
    const campos = Object.keys(data.errors).map((k) => data.errors[k]);
    if (campos.length) return campos.join(" · ");
  }
  if (data && data.error) return data.error;
  return padrao || "Não foi possível concluir.";
}
